import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Media from 'react-media';
import { heading } from '../../../styled/mixins';
import Pipers from '../../../components/Pipers/Pipers';
import GlobalTheme from '../../../styled/GlobalTheme';
import SignupBox from './SignUpBox';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 60px;
  ${GlobalTheme.breakpoints.down('sm')} {
    background: ${({ theme }) => theme.colors.secondary};
    padding: 20px 0;
  }
`;

const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 392px;
  width: 100%;

${GlobalTheme.breakpoints.down('sm')}{
  flex-direction: row-reverse;
  justify-content: center;
  padding: 0 24px;
}
`;

const Heading = styled.h1`
  ${heading}
  margin-bottom: 8px;
  @media ${mediaQueries.xlPlusDownLess} {
    margin-bottom: 11px;
  }
  ${GlobalTheme.breakpoints.down('md')}{
    margin-bottom: 11px;
    font-size: 40px;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 30px;
    text-align:center;
    font-weight: 600;
  }
`;
const PiperContainer = styled.div`
  flex-direction: row;
  width: 120px;
  height: auto;
  margin-right: 10px;
  @media ${mediaQueries.mdUp} {
    display: block;
    width: 185px;
    height: 200px;
  }
  @media ${mediaQueries.xlPlusUp} {
    position: absolute;
    right: 100%;
    height: 400px;
    width: 300px;
    & .piper {
      width: 246px;
      max-width: 100%;
    }
  }
`;

const Header = () => (
  <Media queries={mediaQueries}>
    {(matches) => (
      <Container>
        <HeaderContainer>
          <Heading>
            <FormattedMessage
              id="login.header"
              defaultMessage="Welcome Back!"
            />
          </Heading>
          {matches.mdUp && (
            <SignupBox />
          )}
          <PiperContainer>
            <Pipers.Piper2BigBackground />
          </PiperContainer>
        </HeaderContainer>
      </Container>
    )}
  </Media>
);

export default Header;
